function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.584 19.437c1.081 0 1.958.894 1.958 1.997v8.569c0 1.103-.877 1.997-1.958 1.997-1.08 0-1.957-.894-1.957-1.997v-8.569c0-1.102.876-1.997 1.957-1.997z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.115 9.136a2.699 2.699 0 0 0-.012.23v12.981c0 1.396 1.083 2.521 2.428 2.521h12.938c1.345 0 2.428-1.125 2.428-2.52V9.365c0-.078-.003-.155-.01-.23H7.116z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.75.028a.204.204 0 0 1 .282.077l2.065 3.65c.057.1.023.229-.076.287a.204.204 0 0 1-.281-.077L7.675.315A.213.213 0 0 1 7.75.029zm16.5 0a.213.213 0 0 1 .075.288l-2.065 3.65a.204.204 0 0 1-.281.076.213.213 0 0 1-.076-.287l2.065-3.65a.204.204 0 0 1 .282-.077z",
  clipRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.373 21.435c0-1.103-.876-1.997-1.957-1.997s-1.958.894-1.958 1.997v8.568c0 1.103.877 1.997 1.958 1.997 1.08 0 1.957-.894 1.957-1.997v-8.568zM5.915 12.289c0-1.103-.876-1.998-1.957-1.998S2 11.186 2 12.29v8.568c0 1.103.877 1.997 1.958 1.997s1.957-.894 1.957-1.997V12.29zm24.085 0c0-1.103-.877-1.998-1.958-1.998s-1.957.895-1.957 1.998v8.568c0 1.103.876 1.997 1.957 1.997S30 21.96 30 20.857v-8.568z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.016.596c-4.378.43-7.789 3.7-7.843 7.687h17.654c-.054-3.987-3.465-7.256-7.844-7.687h-1.967zM12.36 5.72a1.01 1.01 0 0 0 1.01-1.012v-.005a1.01 1.01 0 0 0-1.015-1.007 1.01 1.01 0 0 0-1.01 1.012v.006A1.011 1.011 0 0 0 12.36 5.72zm7.56 0a1.01 1.01 0 0 0 1.01-1.012v-.005a1.01 1.01 0 0 0-1.015-1.007 1.01 1.01 0 0 0-1.01 1.012v.006A1.011 1.011 0 0 0 19.92 5.72z",
  clipRule: "evenodd"
});

var SvgAndroid = function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "b21b9e305724d5b3b9ae9091413cf2c9.svg";
export { SvgAndroid as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/android.svg
// module id = null
// module chunks = 